var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import OpportunityService from "../../../Services/Opportunity.service";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import EditAssigneeForm from "../../Presentational/Opportunity/EditAssigneeForm";
const termToRepresentAssignee = "Assignee";
const EditAssigneeModal = (_a) => {
    var { opportunity, currentAssignee, pipelineId, onEdit } = _a, modalProps = __rest(_a, ["opportunity", "currentAssignee", "pipelineId", "onEdit"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { defaultValue: { assignee: currentAssignee !== null && currentAssignee !== void 0 ? currentAssignee : undefined }, handleSubmit: (state) => {
            var _a;
            return OpportunityService.bulkEditAssignee([opportunity.id], (_a = state.assignee) === null || _a === void 0 ? void 0 : _a.personId, pipelineId).then(() => {
                modalProps.onModalClosed();
                if (onEdit) {
                    onEdit(state.assignee ? state.assignee.fullName : "Unassigned");
                    opportunity.assignedTo = state.assignee;
                }
            });
        }, modalTitle: `Edit ${termToRepresentAssignee}`, unMountContentWhenClosed: true, children: _jsx(EditAssigneeForm, { pipelineId: pipelineId }) })));
};
export default EditAssigneeModal;
